import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Typography
} from '@material-ui/core';
import styled from '../../styled';

const Table = styled('div')`
  display: grid;
  margin-top: ${(p) => p.theme.spacing(4)}px;
  grid-row-gap: ${(p) => p.theme.spacing(3)}px;
  grid-template-columns: 1fr 1fr;
  align-items: center;

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

const CommentLink = styled('a')((p) => ({
  borderBottom: `1px solid ${p.theme.palette.grey[300]}`
}));

export const MarkdownSyntaxDialog = ({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <div>Markdown Syntax Cheatsheet</div>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" component="p">
          Here are a couple of quick reminders for how to format text with
          Markdown:
        </Typography>
        <Table>
          <div>
            <code>
              - A list item <br /> - Another list item
            </code>
          </div>
          <div>
            <ul style={{ margin: 0, padding: 0 }}>
              <li>A list item</li>
              <li>Another list item</li>
            </ul>
          </div>
          <div>
            <code>
              1. A list item <br /> 1. Another list item
            </code>
          </div>
          <div>
            <ol style={{ margin: 0, padding: 0 }}>
              <li>A list item</li>
              <li>Another list item</li>
            </ol>
          </div>
          <div>
            <code>[Blogging for Devs](https://bloggingfordevs.com)</code>
          </div>
          <div>
            <CommentLink
              href="https://bloggingfordevs.com"
              rel="nofollow noopener"
              target="_blank"
            >
              Blogging for Devs
            </CommentLink>
          </div>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onClose();
          }}
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};
